module.exports = __webpack_public_path__ + "img/rating_E-adjust.2f57d91b.png";